export enum CalcFormControlNameEnum {
  symptoms = 'symptoms',
  symptomHistory = 'symptomHistory',
  labs = 'labs',
  hormones = 'hormones',
  additionalHormones = 'additionalHormones',
  stressFactor = 'stressFactor',
  problemFactor = 'problemFactor',
  returnVisitCount = 'returnVisitCount',
  estradiolLots = 'estradiolLots',
  testosteroneLots = 'testosteroneLots',
  anastrozoleLots = 'anastrozoleLots',
  anastrozole = 'anastrozole',
  testosterone = 'testosterone',
  estradiol = 'estradiol',
  lotNumber = 'lotNumber',
  valueFromApi = 'valueFromApi',
  capacity = 'capacity',
  title = 'title',
  numeric = 'numeric',
  weeksBeforeAppointment = 'weeksBeforeAppointment',
  weeksSinceLastInsertion = 'weeksSinceLastInsertion',
  dateOfLabDraw = 'dateOfLabDraw',
  mostRecentDosage = 'mostRecentDosage',
  progesterone = 'progesterone',
  isProgesteroneTaken = 'isProgesteroneTaken',
  administeredId = 'administeredId',
  frequencyId = 'frequencyId',
  progesteroneValue = 'progesteroneValue',
  testosteroneDose = 'testosteroneDose',
  additionalDetails = 'additionalDetails',
  administrationRoute = 'administrationRoute',
}
